export default __webpack_public_path__ + "static/media/teamsnap_logo_white.8712ea94.png";